export default {
  methods: {
    // 数据校检 (对外暴露)
    validate(moduleId) {
      if (moduleId) {
        return this.validateOneValue(moduleId)
      } else {
        return this.validateAllValue()
      }
    },

    // 检测所有模块数据
    validateAllValue() {
      const PromiseAll = []
      this.modules.map(module => PromiseAll.push(this.$refs[module.id][0].validate()))
      return new Promise((resolve, reject) => {
        Promise.all(PromiseAll).then(valid => {
          resolve(true)
        }).catch(err => {
          resolve(err)
        })
      })
    },

    // 检测单个一级模块数据
    validateOneValue(moduleId) {
      return new Promise((resolve, reject) => {
        const module = this.modules.find(i => i.id === moduleId);
        if (module) {
          this.$refs[module.id][0].validate().then((res) => {
            resolve(true)
          }).catch((err) => {
            resolve(false)
          })
        } else {
          reject('未查询到此模块')
        }
      })

    }
  }
}
